// extracted by mini-css-extract-plugin
export default {"basicCard":"TheBasicCard_basicCard_N9opM"};